<template>
  <el-collapse-transition>
    <div v-show="showMap" class="map-container">
      <div class="map-wrapper">
        <div class="icon-close" @click="onBackBtnIconClick"></div>
        <div ref="mapPreviewer" id="map-container"></div>
          <ul class="location-list" ref="locationList">
            <li
              v-for="(loc, index) in locationList"
              :key="index"
              class="location-item"
              :data-index="locationList.length > 1 && index+1"
              @click="locationClick($event, loc, index+1)"
            >
              <span class="loc-name">
                {{ loc.city_name }}{{ loc.address && ('-' + loc.address) }}
              </span>
            </li>
          </ul>
      </div>
    </div>
  </el-collapse-transition>
</template>

<script>
import { getAMap } from '@/plugins/amap'
import { mapActions } from 'vuex'

export default {
  props: {
    showMap: {
      type: Boolean,
      required: true
    },
    companyId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      mapLoader: null,
      mapObj: null,
      mapContainerParams: {},
      lng: 121.473701,
      lat: 31.230416,
      locationList: null
    }
  },
  computed: {

  },
  created () {

  },
  mounted () {
    this.initPage()
  },
  methods: {
    ...mapActions('company', ['getCompanyLocation']),

    async initPage () {
      await this.getLocationList()

      this.$nextTick(() => {
        this.initLocations(() => {
          this.getLocationsByLatLng()
        })
      })
    },
    async getLocationList () {
      const resp = await this.getCompanyLocation({ selected_company_id: this.companyId })
      if (resp) {
        this.locationList = resp.location_list
      }
    },
    onBackBtnIconClick () {
      this.$emit('update:showMap', false)
    },
    setSelectedItem () {
      const item = this.$refs.locationList.querySelectorAll('li')
      if (item.length > 0) {
        this.locationClick(item[0], this.locationList[0], 1)
      }
    },
    locationClick (event, loc, index) {
      const lnglat = loc.lnglat
      const locObj = {
        lng: lnglat.lng,
        lat: lnglat.lat,
        index
      }
      this.renderMarker(locObj)
      const list = this.$refs.locationList.querySelectorAll('li')
      if (list) {
        list.forEach(item => {
          item.classList.remove('selected-item')
        })
        const selectedItem = event.currentTarget
        if (!selectedItem) {
          event.classList.add('selected-item')
        } else {
          selectedItem.classList.add('selected-item')
        }
      }
    },
    async renderMarker (item) {
      if (!item.lng && !item.lat) {
        return
      }
      this.mapObj.clearMap()
      if (!this.mapLoader) {
        this.mapLoader = getAMap(undefined, '1.3')
      }
      const AMap = await this.mapLoader
      this.mapObj.setCenter(new AMap.LngLat(item.lng, item.lat))
      const marker = new AMap.Marker({
        position: new AMap.LngLat(item.lng, item.lat),
        icon: new AMap.Icon({
          image: '/static/image/wechat/marker.png',
          size: new AMap.Size(29, 30)
        })
      })
      let markerTemplate
      if (item.index >= 1) {
        markerTemplate = `<div class="marker-icon">
                            <div class="count-marker">
                              <div class="count" >${item.index}</div>
                            </div>
                          </div>`
      } else {
        markerTemplate = `<div class="marker-icon">
                            <div class="count-marker"></div>
                          </div>`
      }
      marker.setContent(markerTemplate)
      marker.setMap(this.mapObj)
    },
    async mapInitialize () {
      this.$refs.mapPreviewer.style.setProperty('height', this.mapContainerParams.mapHeight + 'px')
      this.$refs.locationList.style.setProperty('height', this.mapContainerParams.listHeight + 'px')

      const lang = (navigator.language.indexOf('zh') === -1 ? 'en' : 'zh_cn')
      if (this.mapContainerParams.lat && this.mapContainerParams.lng) {
        this.lng = this.mapContainerParams.lng
        this.lat = this.mapContainerParams.lat
      }
      if (this.mapObj) {
        this.mapObj.destroy()
      }
      if (!this.mapLoader) {
        this.mapLoader = getAMap(undefined, '1.3')
      }
      const AMap = await this.mapLoader
      this.mapObj = new AMap.Map('map-container', {
        view: new AMap.View2D({
          center: new AMap.LngLat(this.lng, this.lat),
          zoom: 16,
          rotation: 0
        }),
        lang: lang
      })
    },
    initLocations (callback) {
      navigator.geolocation.getCurrentPosition(position => {
        this.mapContainerParams.lng = position.coords.longitude
        this.mapContainerParams.lat = position.coords.latitude
        callback()
      }, () => {
        callback()
      }, {
        enableHighAccuracy: true,
        maximumAge: 5000,
        timeout: 1000
      })
    },
    getLocationsByLatLng () {
      this.hideLocations()
      this.mapInitialize()
      this.setSelectedItem()
    },
    hideLocations () {
      const locationCount = this.locationList.length
      const width = window.innerWidth
      const itemHeight = width < 768 ? 39 : 78
      const height = window.innerHeight
      const listHeight = locationCount <= 4 ? locationCount * itemHeight : 3.5 * itemHeight
      const mapHeight = height - (listHeight + 20)

      this.mapContainerParams.mapHeight = mapHeight
      this.mapContainerParams.listHeight = listHeight
      this.mapContainerParams.itemHeight = itemHeight
    }
  }
}
</script>
<style lang="scss" scoped>
.map-container {
  position: fixed;
  bottom: 0;
  top:0;
  z-index: 100;
  width: 100%;
  background-color: #fff;

  .icon-close {
    position: absolute;
    left: 10px;
    top: 10px;
    width: 32px;
    height: 32px;
    background: url($baseDomain + 'static/image/mobile_web/icon_close_map.png');
    background-size: 100% 100%;
    z-index: 1;
  }

  .location-list {
    padding: 10px 5px;
    font-size: 13px;
    overflow: auto;

    .selected-item {
      color: var(--custom-color, #fc8434);
      border-color: var(--custom-color, #fc8434);
    }

    .location-item {
      border: 1px solid #b9bcbd;
      border-radius: 30px;
      margin: 0 0 10px 0;
      padding: 7px;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
  }

  ::v-deep .amap-marker-content {
    position: relative;
    .marker-icon {
      background: url($baseDomain + 'static/image/wechat/marker.png') no-repeat;
      width: 25px;
      height: 35px;
      background-size: 100% 100%;

      .count-marker {
        position: relative;
        width: 31px;
        height: 30px;
        background: transparent;
        top: -4px;
        left: -3px;

        div {
          position: absolute;
          top: 0;
          bottom: 0;
          left: 0;
          right: 0;
          margin: auto;
          width: 20px;
          height: 20px;
          text-align: center;
          line-height: 20px;
          background: #efa113;
          color: #fff;
          border-radius: 10px;
        }
      }
    }
  }
}
</style>
